"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/**
 * Created by vadimdez on 20/01/2017.
 */
__export(require("./src/ng2-order.module"));
__export(require("./src/ng2-order.pipe"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/ng2-order-pipe/dist/index.js
// module id = ../../../../ng2-order-pipe/dist/index.js
// module chunks = 5